/* @ngInject */

export default function AuthInterceptorService(
	$q,
	$state,
	$window,
	$timeout,
	$location,
	$rootScope,
	PretorCache,
	$cacheFactory,
	LocalStorageService,
	AuthorizationService
) {
	var cacheName = 'pretorCache';
	var isLoaderCached = false;
	var cache = $cacheFactory(cacheName);
	var sessionPromise;
	var _intervalPromise;
	var requestsCollection = [];

	/**
	 * Function for attaching the authorization token for each call
	 * @param {Object} config The config object
	 * @returns {Object} config The config object
	 */
	function request(config) {
		var requestObj;
		config.headers = config && config.hasOwnProperty('headers') ? config.headers : {};
		config = setSchemeRef(config);

		var url = config.url.toLowerCase().trim();

		var oldRequest = _getOldRequest(url);

		if (oldRequest) return $q.when(config);

		_saveRequest(url);

		if (
			url.indexOf(pretorOnlineUrl.toLowerCase()) > -1 &&
			url.indexOf('link') == -1 &&
			url.indexOf('api') > -1 &&
			url.indexOf('impersonate') === -1 &&
			url.indexOf('schemelogin') === -1 &&
			url.indexOf('contactus') === -1 &&
			url.indexOf('clearance') === -1 &&
			url.indexOf('contractors') === -1
		) {
			var session = LocalStorageService.retrieve('userSession');
			var user = LocalStorageService.retrieve('userProfile');
			if (session && user) {
				if (session['SessionToken'] && user['UserName']) {
					requestObj = _continueRequest(config, session, user);
				} else {
					requestObj = $q.reject(config);
				}
			}
		} else {
			requestObj = $q.when(config);
		}

		if (requestObj) {
			requestObj.finally(function(results) {
				_removeRequest(url);
			});
		}

		return requestObj;
	}

	/**
	 * Ensures that the Scheme Reference header is set in all XHR calls
	 * @param {object} config The configuration object
	 * @returns {object} config The configuration object with scheme reference
	 */
	function setSchemeRef(config) {
		const url = config.url.toLowerCase().trim();

		let schemeRef = LocalStorageService.retrieve('selectedBuildingRef');
		if (schemeRef && typeof schemeRef === 'object') {
			schemeRef = schemeRef.SchemeReference;
		}

		if (
			url.indexOf(pretorOnlineUrl.toLowerCase()) > -1 &&
			url.indexOf('link') === -1 &&
			url.indexOf('api') > -1 &&
			url.indexOf('impersonate') === -1 &&
			url.indexOf('contactus') === -1
		) {
			if (schemeRef) {
				config.headers.schemeRef = schemeRef;
			}
		}

		return config;
	}

	/**
	 * Function for handling errors
	 * @param {Object} rejection The rejection object
	 * @returns {Promise} The rejected promise
	 */
	function responseError(rejection) {
		const { status, config } = rejection;

		if (!config) {
			return $q.reject(rejection);
		}

		let url = config.url.toLowerCase();
		if (status === 401 && (!url.includes('auth') || url.includes('payment'))) {
			const path = AuthorizationService.unProtectedRoute;
			$state.go(path);
		}
		return $q.reject(rejection);
	}

	function _continueRequest(config, session, user) {
		var requestObj;
		var token = session.SessionToken;
		if (token) {
			config.headers.sessionToken = config.headers.sessionToken || token;
			config.headers.userName = config.headers.userName || user.UserName;

			requestObj = $q.when(config);
		} else {
			requestObj = $q.reject(config);
		}

		return requestObj;
	}

	function _getOldRequest(url) {
		var oldRequest = _.find(requestsCollection, function(req) {
			var found = req.toLowerCase().trim() === url;
			return found;
		});

		return oldRequest;
	}

	function _saveRequest(url) {
		requestsCollection.push(url);
	}

	function _removeRequest(url) {
		$timeout(function() {
			requestsCollection = _.remove(requestsCollection, function(request) {
				return request.toLowerCase().trim() === url;
			});
		}, 1500);
	}

	return {
		request: request,
		responseError: responseError
	};
}
